import { ImageObj } from '../../interface/image-obj';

export class Bank {
    name: string;
    id: number;
    code: string;
    site: string;
    image: ImageObj;
}